import { UserRole } from '@/components/authnz/types/rbac';

export type PractitionerAdminMutationInput = {
  productUserRole: unknown;
  requestedUserRole?: unknown;
  persistedUserRole?: unknown;
};

/**
 * Subscriptions that grant the practitioner role only.
 * Used by practitioner-administrator UI filters and server enforcement.
 */
export function isPractitionerRoleGrant(role: unknown): boolean {
  return role === UserRole.PRACTITIONER;
}

/**
 * Whether a practitioner administrator may create/update/cancel/assign-emails
 * for a subscription. Both the product grant and any persisted/requested
 * subscription role must be `UserRole.PRACTITIONER`, and a requested body
 * `userRole` must match the product.
 */
export function canPractitionerAdminMutateSubscription(
  input: PractitionerAdminMutationInput,
): boolean {
  if (!isPractitionerRoleGrant(input.productUserRole)) {
    return false;
  }

  if (
    input.persistedUserRole !== undefined &&
    !isPractitionerRoleGrant(input.persistedUserRole)
  ) {
    return false;
  }

  if (input.requestedUserRole !== undefined) {
    if (!isPractitionerRoleGrant(input.requestedUserRole)) {
      return false;
    }
    if (input.requestedUserRole !== input.productUserRole) {
      return false;
    }
  }

  return true;
}

export function productsAssignableByActor<T extends { userRole: unknown }>(
  products: T[],
  isFullAdministrator: boolean,
): T[] {
  if (isFullAdministrator) {
    return products;
  }
  return products.filter((product) => isPractitionerRoleGrant(product.userRole));
}
